var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert-modal',{attrs:{"title":_vm.title,"superTitle":_vm.$t('OOS_WARNING_SUPER'),"primaryCTAText":_vm.$t('ACTION_OKAY')},on:{"close":_vm.close,"cancel":_vm.close,"confirm":_vm.close,"overlayClick":_vm.close}},[_c('div',{staticClass:"cz2__modal-popup__copy"},[_vm._v(" "+_vm._s(_vm.bodyCopy)+" "),_c('div',{staticClass:"cz2__oos-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }